/** Signature-date fields: link to a parent signature and format its clientDate. */

export const SIGNATURE_DATE_TYPE = 'signatureDate'

export function isoDateFromSignatureValue(value: unknown): string {
  if (!value || typeof value !== 'object') return ''
  const clientDate = String((value as { clientDate?: unknown }).clientDate || '').trim()
  const iso = clientDate.match(/^(\d{4}-\d{2}-\d{2})/)
  return iso ? iso[1] : ''
}

export function formatSignatureDate(value: unknown, format = 'MM/DD/YYYY'): string {
  const raw = String(value || '').trim()
  if (!raw) return ''
  let y = ''
  let m = ''
  let d = ''
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) {
    y = iso[1]
    m = iso[2]
    d = iso[3]
  } else {
    const mdy = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)
    if (!mdy) return raw
    m = mdy[1].padStart(2, '0')
    d = mdy[2].padStart(2, '0')
    y = mdy[3]
  }
  if (format === 'YYYY-MM-DD') return `${y}-${m}-${d}`
  return `${m}/${d}/${y}`
}

export function collectLeafQuestions(form: { steps?: Array<{ questions?: any[] }> } | null | undefined): any[] {
  const fields: any[] = []
  if (!form) return fields
  const walk = (node: any) => {
    if (!node) return
    if (node.type === 'group') {
      for (const child of node.questions || []) walk(child)
      return
    }
    fields.push(node)
  }
  for (const step of form.steps || []) {
    for (const q of step.questions || []) walk(q)
  }
  return fields
}

export function applySignatureDateAnswers(
  answers: Record<string, any>,
  form: { steps?: Array<{ questions?: any[] }> } | null | undefined,
  opts?: { sourceFieldId?: string; overwrite?: boolean },
): string[] {
  const updatedIds: string[] = []
  const dependents = collectLeafQuestions(form).filter((f) =>
    f?.type === SIGNATURE_DATE_TYPE &&
    f?.signatureSource &&
    (!opts?.sourceFieldId || f.signatureSource === opts.sourceFieldId),
  )
  for (const dep of dependents) {
    const iso = isoDateFromSignatureValue(answers[dep.signatureSource])
    const current = answers[dep.id]
    if (!iso) {
      if (current !== undefined && current !== null && String(current).trim() !== '') {
        answers[dep.id] = undefined
        updatedIds.push(dep.id)
      }
      continue
    }
    const empty = current === undefined || current === null || String(current).trim() === ''
    if (opts?.overwrite || empty) {
      if (current !== iso) {
        answers[dep.id] = iso
        updatedIds.push(dep.id)
      }
    }
  }
  return updatedIds
}

export function pdfTextForSignatureDate(question: any, value: unknown): string {
  if (value == null || String(value).trim() === '') return ''
  return formatSignatureDate(value, question?.format || 'MM/DD/YYYY')
}
